var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.course.description)?_c('div',{staticClass:"fill fill-grey mt-24"},[_c('h2',{staticClass:"text-rothek font-36 mb-20 mt-20"},[_vm._v(_vm._s(_vm.$t('course.about')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.clearStyle(_vm.course.description))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }